import { render, staticRenderFns } from "./user-auth.vue?vue&type=template&id=ec8da7b0&"
import script from "./user-auth.vue?vue&type=script&lang=js&"
export * from "./user-auth.vue?vue&type=script&lang=js&"
import style0 from "./user-auth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec8da7b0')) {
      api.createRecord('ec8da7b0', component.options)
    } else {
      api.reload('ec8da7b0', component.options)
    }
    module.hot.accept("./user-auth.vue?vue&type=template&id=ec8da7b0&", function () {
      api.rerender('ec8da7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/user-auth.vue"
export default component.exports